var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConsoltoLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_232322",
    "data-name": "Group 232322",
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.489,
    height: 22.572,
    viewBox: "0 0 47.489 22.572",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Comment",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Chat",
    d: "M15.518,11.286A1.333,1.333,0,0,1,14.108,12.7H8.465a1.414,1.414,0,0,1-1.411-1.411A1.333,1.333,0,0,1,8.465,9.875h5.643A1.414,1.414,0,0,1,15.518,11.286Zm7.054-4.232A6.985,6.985,0,0,0,15.518,0H7.054A6.985,6.985,0,0,0,0,7.054V21.161a1.333,1.333,0,0,0,1.411,1.411H15.518a6.985,6.985,0,0,0,7.054-7.054Z",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Comment-2",
    "data-name": "Comment",
    transform: "translate(24.917 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Chat-2",
    "data-name": "Chat",
    d: "M7.054,11.286A1.333,1.333,0,0,0,8.465,12.7h5.643a1.414,1.414,0,0,0,1.411-1.411,1.333,1.333,0,0,0-1.411-1.411H8.465A1.414,1.414,0,0,0,7.054,11.286ZM0,7.054A6.985,6.985,0,0,1,7.054,0h8.465a6.985,6.985,0,0,1,7.054,7.054V21.161a1.333,1.333,0,0,1-1.411,1.411H7.054A6.985,6.985,0,0,1,0,15.518Z",
    transform: "translate(0 0)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsoltoLogo);
export default __webpack_public_path__ + "static/media/consolto-logo.dcab44bc0cb674e95a99a0e56aae8551.svg";
export { ForwardRef as ReactComponent };